export function resolveHsocCardBadges({
  tiers,
  serverBadgeNameByApiName,
  limitedTimeOfferDiscountByTierName,
  recommendedTierName
}) {
  const badges = {};
  tiers.forEach(({
    tierName,
    productApiName
  }) => {
    if (serverBadgeNameByApiName[productApiName] === 'CURRENT_PLAN') {
      badges[tierName] = {
        type: 'currentPlan'
      };
      return;
    }
    const discountPercentage = limitedTimeOfferDiscountByTierName === null || limitedTimeOfferDiscountByTierName === void 0 ? void 0 : limitedTimeOfferDiscountByTierName[tierName];
    if (discountPercentage != null) {
      badges[tierName] = {
        type: 'limitedTimeOffer',
        discountPercentage
      };
      return;
    }
    if (recommendedTierName === tierName) {
      badges[tierName] = {
        type: 'recommended'
      };
    }
  });
  return badges;
}

/*
 * GrowthPOP tags structural, non-promotional discounts (e.g. the annual
 * payment discount) with a promotionId prefixed NO_PROMOTION_ — e.g.
 * NO_PROMOTION_10_PERCENT_ANNUAL, NO_PROMOTION_25_PERCENT_ANNUAL,
 * NO_PROMOTION_10_PERCENT_ANNUAL_MARKETING_PRO. A genuine limited-time offer
 * carries a real promotion key, so only those should drive the LTO badge.
 */
const NON_PROMOTIONAL_DISCOUNT_ID_PREFIX = 'NO_PROMOTION';
export function isPromotionalDiscount({
  promotionId,
  discountedAmountPerPurchase
}) {
  return !!promotionId && !promotionId.startsWith(NON_PROMOTIONAL_DISCOUNT_ID_PREFIX) && Number(discountedAmountPerPurchase) > 0;
}
export function buildLimitedTimeOfferDiscountByTierName({
  isPaidPortal,
  starterDiscountPercentage
}) {
  if (isPaidPortal || starterDiscountPercentage == null) {
    return undefined;
  }
  return {
    STARTER: starterDiscountPercentage
  };
}